import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ListaPropostas from '../ListaPropostas/ListaPropostas';



class ListaPropostasEmAnalise extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render() {

    return (
      <ListaPropostas history={this.props.history}/>
    );

  }

}

ListaPropostasEmAnalise.propTypes = {
  history: PropTypes.object
};

export default withRouter(ListaPropostasEmAnalise);